// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"basket-amount-visuallyHidden--aeac0","icon":"basket-amount-icon--c2f1a","icon__tn":"basket-amount-icon__tn--1fc05"};